class PDPImageSlider extends HTMLElement {
  constructor() {
    super();

    this.swiperInstance = null;
    this.swiperContainerId = this.id;
    this.dataId = null;
  }

  connectedCallback() {
    this.dataId = this.getAttribute('data-id');
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(false, false);
    }
  }

  initSwiper() {
    if (window.Swiper) {
      const paginationEnabled = {
        pagination: {
          el: `#swiper-pagination-${this.dataId}`,
          type: 'bullets',
          clickable: false,
        },
      };

      const navigationEnabled = {
        navigation: {
          nextEl: `#swiper-button-next-${this.dataId}`,
          prevEl: `#swiper-button-prev-${this.dataId}`,
        },
      };

      this.swiperInstance = new Swiper(`#${this.swiperContainerId}`, {
        ...paginationEnabled,
        ...navigationEnabled,
        speed: DEFAULT_SLIDER_SPEED,
        loop: true,
        slidesPerView: 1,
        watchOverflow: true,
        effect: 'slider',
        observer: true,
        draggable: true,
        preventInteractionOnTransition: true,
      });
    } else {
      console.warn('Swiper.js is not loaded.');
    }
  }
}

customElements.define('pdp-image-slider', PDPImageSlider);
